import React from 'react';
import type { IconProps } from '@models/types';
import { styled } from '@mui/material/styles';

const Icon: React.FC<IconProps> = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='24'
        height='24'
        viewBox='0 0 24 24'
        fill='none'
        {...props}
    >
        <path
            d='M12.4004 2C15.7603 2 17.4402 2.00042 18.7236 2.6543C19.8526 3.22954 20.7705 4.14739 21.3457 5.27637C21.9996 6.55977 22 8.23965 22 11.5996V12.4004C22 15.7603 21.9996 17.4402 21.3457 18.7236C20.7705 19.8526 19.8526 20.7705 18.7236 21.3457C17.4402 21.9996 15.7603 22 12.4004 22H11.5996C8.23965 22 6.55977 21.9996 5.27637 21.3457C4.14739 20.7705 3.22954 19.8526 2.6543 18.7236C2.00042 17.4402 2 15.7603 2 12.4004V11.5996C2 8.23965 2.00042 6.55977 2.6543 5.27637C3.22954 4.14739 4.14739 3.22954 5.27637 2.6543C6.55977 2.00042 8.23965 2 11.5996 2H12.4004Z'
            fill='currentColor'
        />
        <path
            d='M19.9757 9.80133C20.0719 9.99688 20.0783 10.7829 16.0289 12.5725L12.0586 14.3272C10.6767 14.9382 8.67178 15.7417 7.7877 15.9639C7.16868 16.1191 6.57794 15.7235 6.57794 15.7235C6.57794 15.7235 4.79524 14.2207 4.32168 13.8828C3.84893 13.545 3.88934 13.373 4.49543 13.1904C4.87282 13.077 7.02483 13.5655 7.94205 13.7839C8.7785 13.3122 9.62477 12.8561 10.4803 12.4158C9.35221 11.6298 7.24141 10.162 6.56825 9.71458C5.92256 9.28467 6.57633 9.13021 6.57633 9.13021C6.87372 9.05488 7.51536 8.95672 7.83861 9.02064C10.0375 9.45359 13.708 10.5965 13.9892 10.684C14.7691 10.2991 15.5563 9.92743 16.3505 9.56925C18.0273 8.82813 19.8472 9.5411 19.9757 9.80133Z'
            fill='white'
        />
    </svg>
);

export const AirplaneIcon = styled(Icon)({});
